export const GRID_SELECTED_FIELD = "selected";
